import React from 'react';

import { SVGPropsType } from 'src/types';

function Down(props: SVGPropsType) {
    const { stroke, onClick, style, className } = props;

    return (
        <svg
            width="7"
            height="5"
            viewBox="0 0 7 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M6.3125 1.0625L3.5 3.875L0.6875 1.0625"
                stroke={stroke}
                strokeWidth="1.08395"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default Down;
